import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import App from './App';
import { EmbedClientPage } from './pages/embed/EmbedClientPage';
import { EmbedStudioPage } from './pages/embed/EmbedStudioPage';

export default function RootApp() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/embed/client" element={<EmbedClientPage />} />
        <Route path="/embed/studio" element={<EmbedStudioPage />} />
        <Route path="/*" element={
          <ThemeProvider>
            <App />
          </ThemeProvider>
        } />
      </Routes>
    </AuthProvider>
  );
}
